







import { Component, Vue, Prop } from 'vue-property-decorator'
import { Action } from '@/api/model/action'

@Component
export default class ActionLabel extends Vue {
    @Prop({ required: true}) readonly action!: Action
    @Prop({ type: Boolean, default: false }) readonly xs!: boolean

    colorForActionType(action: Action): string {
        switch (action.type) {
            case 'meeting': return 'kvUnitedBlue'
            case 'email': return 'vueOrange'
            case 'call': return 'vueViolet'
            case 'reminder': return 'pink'
            case 'letter': return 'indigo'
            case 'billing': return 'green'
            case 'update': return 'teal'
            default: return 'blue'
        }
    }

    iconForActionType(action: Action): string {
        switch (action.type) {
            case 'meeting': return 'icon-meeting-action'
            case 'email': return 'icon-email-action'
            case 'call': return 'icon-call-action'
            case 'reminder': return 'icon-reminder-action'
            case 'letter': return 'icon-letter-action'
            case 'billing': return 'icon-billing'
            case 'update': return 'icon-update-action'
            case 'notification': return 'icon-reminder-action'
            default: return 'icon-task-action'
        }
    }

    iconClassesForActionType(action: Action): string[] {
        return [
            `action-label`,
            `bg-${this.colorForActionType(action)}-100`,
            `text-${this.colorForActionType(action)}-500`,
            `inline-flex rounded-full items-center`,
        ]
    }

    get componentClass() {
        return {
            'p-2 px-4': !this.xs,
            'p-1 px-3': this.xs,
        }
    }
}
